export default function useFilterLogic(value: string, checkedItems: string[]) {
  if (!checkedItems.includes(value)) {
    checkedItems.push(value);
  } else {
    const filteredItems = checkedItems.filter(
      (checkedItem) => checkedItem !== value,
    );
    checkedItems = filteredItems;
  }
  return checkedItems;
}
